import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/crm/Cliente/Details/{id}',
  alias: ['/sistema/crm/Cliente/Details', '/sistema/crm/Cliente/Edit/{id}'],
  documento: 'crm',
  filas: ['129'],
  acceso: 'sesion',
  cita: 'prod:Areas/CRM/Controllers/ClienteController.cs:38-39,893-900',
} satisfies RutaProd;
